import { render } from "./ObrasSolicitacaoStatusSelect.vue?vue&type=template&id=1988919a"
import script from "./ObrasSolicitacaoStatusSelect.vue?vue&type=script&lang=js"
export * from "./ObrasSolicitacaoStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__